<img
  #image
  class="overflow-icon"
  [src]="iconSrc"
  alt=""
  tabindex="0"
  role="button"
  [attr.aria-label]="ariaLabel"
  [attr.aria-expanded]="expanded"
  [attr.aria-controls]="id"
>
<ods-card #overflowOptionsMenu class="overflow-options-menu" [id]="id">
  <ul>
    <li
      *ngFor="let item of config"
      class="overflow-option"
      tabindex="0"
      role="button"
      [attr.aria-disabled]="item.disabled(metadata)"
      [attr.aria-label]="item.ariaLabel(metadata)"
      (click)="item.callback($event, metadata)"
      (keydown.enter)="item.callback($event, metadata)"
    >
      <ods-link
        tabindex="-1"
        [dataDisabled]="item.disabled(metadata)"
      >{{ item.text }}</ods-link>
    </li>
  </ul>
</ods-card>
